export default __webpack_public_path__ + "static/media/containerGallery.7560f5a0.png";